var _rect, _rect2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 19,
    height: 22,
    fill: "url(#pattern0_86_931)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    width: 12,
    height: 15,
    fill: "url(#pattern1_86_931)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_86_931",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_86_931",
    transform: "scale(0.0526316 0.0454545)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_86_931",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_86_931",
    transform: "scale(0.0833333 0.0666667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_86_931",
    width: 19,
    height: 22,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAWCAMAAAAVQ1dNAAAAAXNSR0IB2cksfwAAAMNQTFRF6W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W866W862X5cXwAAAEF0Uk5TAHROv3cT9q8GZP7sHgjG/4hg/Cb0xQ4czaco06sNbuPZVTqK189tOITDu2cHWdpEA54SxJ8f7g9YLsGV8CG4flMqGWvxAAAAwklEQVR4nF3QUQvBUBQH8PNvKGpKatPkwQrRvKyUJ5+dJCkPXiTFg8QyKUVZpsvd2p27ex/OOf26nXvOBYkDMFGlpuGjWh5AoFiR2zNrOkC4Z63Coo432aoIeSzA/5uJV5xLXmqW6E56eImtAdE86gsvgA1cSTphHegAZ9m0Gp+KHOCQ3so1sYrfMNk7Mfvki1lc7OLcWkozD7Dl8dtdyLsNNzz05pl9nfKanJnyV/29i6liBjOOD8VohAmp1rbGSfUDGc8raLKN5vYAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_86_931",
    width: 12,
    height: 15,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAPCAMAAADnP957AAAAAXNSR0IB2cksfwAAAJ9QTFRF////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////E6xt/AAAADV0Uk5TAHEW2Dwx+ZMEn//oIFe7AVH4pxESMpL10brwBRBj5PumMCvlgAM396IChf7iHCH2h849bBieSTrBAAAAd0lEQVR4nGNkAANGxn8gEsJhZvwD57AyMv6EcTgYgeALlMP7l4GBhfEjmCMAVsPB+JZRBKjiM1gj31dGXp6PDFAgwCgNlHkDYooCGUBKifE5kJRivA02TY3xMYPcDajRmiB7LsNcoMfIeAHhNkPGcwiOMeMZIAkAqp4UWFJL+qgAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleStar);
export default __webpack_public_path__ + "static/media/DoubleStar.c34b4c1a5bb99d4bb25956c2a4812670.svg";
export { ForwardRef as ReactComponent };